import { render, staticRenderFns } from "./Threshold.vue?vue&type=template&id=60a5f25c&scoped=true"
import script from "./Threshold.vue?vue&type=script&lang=js"
export * from "./Threshold.vue?vue&type=script&lang=js"
import style0 from "./Threshold.vue?vue&type=style&index=0&id=60a5f25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5f25c",
  null
  
)

export default component.exports